// ------------------------------------------------------------------------------
// Html 2 Image
import { get } from 'svelte/store'
import { text_entered } from '../stores'
import toBlob from 'canvas-toBlob'
import saveAs from 'file-saver'
import html2canvas from './html2canvas_modified.min'
let exported_zoomed_fontname

export function createImage(element, target, preferedScale = 1, callbackFunction) {
  let _scrollY = element.offsetTop < 60 ? 0 : -window.scrollY // hack for both previews and zoomed previews
  if (document.getElementsByClassName('zoomed')[0]) {
    exported_zoomed_fontname = document.querySelectorAll('.zoomed .fontname')[0].textContent
  } else {
    exported_zoomed_fontname = undefined
  }
  html2canvas(element, {backgroundColor: null, scrollX: 0, scrollY: _scrollY, scale: preferedScale}).then(canvas => {
    target.style.backgroundImage = 'url(' + canvas.toDataURL() + ')'
    callbackFunction(canvas)
  })
}

export function saveImage(canvas) {
  let filename = get(text_entered).trim() 
  if (exported_zoomed_fontname) {
    filename = filename.substring(0, 24) + ' set with ' + exported_zoomed_fontname
  }
  else {
    filename = filename.substring(0, 24) + ' wordmarks'
  }
  canvas.toBlob(function(blob) {
    saveAs(blob, filename + ".png")
  })
}

export function cloneForPrintPreview(paper_width_mm, paper_height_mm, margin_mm, preview_target, calbackFunction) {
  // is there a zoomed preview?
  let zoomed = document.getElementsByClassName('zoomed')[0] ? true : false
  // get zoomed preview or 140 selected previews element (we need them only for the first page of preview)
  let element = zoomed ? document.getElementsByClassName('zoomed')[0] : document.querySelectorAll('.preview:nth-of-type(-n+' + 140 + ')');
  // clone element
  let print_clone
  if (zoomed) {
    print_clone = element.cloneNode(true);
  } 
  else {
    print_clone = document.createElement("div")
    print_clone.classList = document.getElementsByClassName('previews')[0].classList
    element.forEach((e) => print_clone.appendChild(e.cloneNode(true)))
  }
  print_clone.style.width = paper_width_mm + 'mm'
  print_clone.style.height = paper_height_mm + 'mm'
  print_clone.style.padding = margin_mm + 'mm'
  print_clone.classList.add('print_clone') 
  // append to preview_target
  preview_target.innerHTML = print_clone.outerHTML

  calbackFunction()

}